import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { CollabMergeResult, ConflictResolutionResult } from '@common/collab/models/collab-merge-result.model';
import { DialogBase } from '@portal-core/ui/dialog/util/dialog.base';

export interface CollabConflictResolutionDialogData {
  action?: string;
  branchName: string;
  conflictResolutionResult: ConflictResolutionResult;
  licenseId: number;
  projectId: number;
  title?: string;
}

@Component({
  selector: 'mc-collab-conflict-resolution-dialog',
  templateUrl: './collab-conflict-resolution-dialog.component.html',
  styleUrls: ['./collab-conflict-resolution-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollabConflictResolutionDialogComponent extends DialogBase<CollabConflictResolutionDialogComponent> implements OnInit {
  static DialogConfig: MatDialogConfig = {
    width: '52rem'
  };

  /** Generic merge failures (corrupted state, network, etc.) — the user is asked to resolve via an external commit. */
  failedMerges: CollabMergeResult[];
  /** Failures specifically caused by a live editor racing the pull's merge write past the OCC retry budget — the user is asked to wait for the editor to idle and retry. */
  concurrentEditMerges: CollabMergeResult[];
  successfulMerges: CollabMergeResult[];

  constructor(
    protected dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: CollabConflictResolutionDialogData,
    protected dialogRef: MatDialogRef<CollabConflictResolutionDialogComponent>
  ) {
    super(dialog, dialogRef);

    const merged = this.data.conflictResolutionResult?.merged ?? [];
    this.successfulMerges = merged.filter(item => item.success);
    const failed = merged.filter(item => !item.success);
    // Split failures by reason so the dialog can render distinct copy. Anything without a `reason`
    // discriminator falls into the generic bucket for back-compat.
    this.concurrentEditMerges = failed.filter(item => item.reason === 'concurrent-edit');
    this.failedMerges = failed.filter(item => item.reason !== 'concurrent-edit');
  }
}
